import React from "react";
import Modal from "../../../../shared-components/css-modules/toyota/organisms/Modal";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import type { DisclaimerModalType } from "../../../utils/modalConstants";
import { useAphBreakpoint } from "../../../../shared-logic/hooks/useBreakpoint";

const DisclaimerModal = (props: ModalViewType<DisclaimerModalType>): JSX.Element | null => {
    const { show, close, modalSettings } = props;
    const { content } = modalSettings;
    const isMobile = useAphBreakpoint("down", "xl");

    if (!content) return null;

    return (
        <Modal open={show} onRequestClose={close} variant={isMobile ? "fullscreen" : "content-height"}>
            {content}
        </Modal>
    );
};

export default DisclaimerModal;
